// Male Partner Treatment Flow Constants

export const MALE_PARTNER_ELIGIBILITY_COPY = {
  TITLE: "Confirm Eligibility",
  SUBTITLE: "Male Partner Bacterial Vaginosis Treatment",
  MALE_PARTNER_MUST_COMPLETE_WARNING:
    "This treatment must be purchased and the intake form completed by the male partner — not from your account. Using your account will delay or cancel his treatment.",
  TREATMENT_CRITERIA_TITLE: "Treatment Criteria",
  TREATMENT_CRITERIA_SUBTEXT:
    "To make sure you qualify for this treatment — confirm all of the below statements are true, then continue to checkout.",
  CRITERIA: {
    PARTNER_WITH_BV:
      "My sexual partner has a recent diagnosis or treatment for Bacterial vaginosis (BV)",
    MALE_AT_BIRTH: "I was assigned male at birth",
    CLINICIAN_TREATMENT:
      "If I'm being treated by another clinician for any condition, I'll discuss this treatment with them",
    NO_EMERGENCY:
      "I am not experiencing a potentially life-threatening emergency* and I do not have active symptoms, including no open sores on my penis",
  },
  CONFIRMATION_TEXT: "I confirm the above is all true",
  CONTINUE_BUTTON: "Continue",
  EMERGENCY_DISCLAIMER:
    "*If you are experiencing a medical emergency, please seek treatment for such immediately by calling 911 or proceeding to your nearest emergency room.",
  CLARIFICATION_MODAL: {
    TITLE:
      "This product must be purchased by the intended patient assigned male at birth.",
    DESCRIPTION:
      "You are currently logged in to an existing Evvy account. Please choose one of the following options in order to proceed:",
    CONTINUE_WITH_NEW_ACCOUNT: "Continue with New Account",
    SHARE_LINK_WITH_PARTNER: "Share Link with My Partner",
    COPIED_FEEDBACK: "COPIED!",
  },
  SHARING: {
    PRODUCT_URL: "https://www.evvy.com/male-partner-bv-treatment",
    SHARE_TITLE: "Male Partner BV Treatment - Evvy",
    SHARE_DESCRIPTION:
      "A science-backed antibiotic regimen for men designed to help your female partner break the cycle of BV.",
  },
};

export const MALE_PARTNER_REGISTER_COPY = {
  TITLE: "Create Account",
  SUBTITLE: null, // No subtitle for male partner registration
  META_TITLE: "Create Account | Male Partner Treatment | Evvy",
};

export const MALE_PARTNER_LOGIN_COPY = {
  TITLE: "Sign In",
  SUBTITLE: null, // No subtitle for male partner login
  META_TITLE: "Sign In | Male Partner Treatment | Evvy",
};

export const MALE_PARTNER_PRODUCT_COPY = {
  DEFAULT_PRODUCT: {
    NAME: "Male Partner Bacterial Vaginosis Treatment",
    PRICE: 129,
    SKU: "MP-BV-001",
    BUNDLE_IMAGE_URL:
      "https://evvy-public-content.s3.us-east-2.amazonaws.com/product_images/mp-1-bundle.png",
  },
  FREE_SHIPPING: "Free Shipping",
};

// Analytics versions for male partner flow
export const MALE_PARTNER_ANALYTICS = {
  VERSION: "male-partner",
  EVENTS: {
    ELIGIBILITY_VIEWED: "male_partner_eligibility_viewed",
    ELIGIBILITY_CONTINUE: "male_partner_eligibility_continue",
    REGISTRATION_VIEWED: "male_partner_registration_viewed",
    LOGIN_VIEWED: "male_partner_login_viewed",
  },
};

// Session storage keys for male partner flow
export const MALE_PARTNER_SESSION_KEYS = {
  ELIGIBILITY_COMPLETED: "malePartnerEligibilityCompleted",
  PRODUCT: "malePartnerProduct",
};

// Utility functions for male partner session management
export const clearMalePartnerSession = () => {
  sessionStorage.removeItem(MALE_PARTNER_SESSION_KEYS.ELIGIBILITY_COMPLETED);
  sessionStorage.removeItem(MALE_PARTNER_SESSION_KEYS.PRODUCT);
};

export const MALE_PARTNER_ALLOWED_ROUTES = [
  "/care/",
  "/treatments/",
  "/account/",
  "/research-consent/",
  "/verify-email/",
];

export const isMalePartnerAllowedRoute = (pathname) => {
  return MALE_PARTNER_ALLOWED_ROUTES.some((route) =>
    pathname.startsWith(route)
  );
};
